import { useMemo } from 'react';
import { NoteContent } from '#/components/notes/note-content.tsx';
import { extractHeadings } from '@/components/notes/table-of-contents.utils';
import { api } from '@/lib/trpc/client';

const OWNER = 'sohanemon';

type ReadmeContentProps = {
	repo: string;
	noToc?: boolean;
};

export function ReadmeContent({ repo, noToc }: ReadmeContentProps) {
	const [content] = api.github.readme.useSuspenseQuery({ repo });
	const headings = useMemo(() => extractHeadings(content), [content]);

	return (
		<NoteContent
			content={content}
			headings={headings}
			imgBase={`https://raw.githubusercontent.com/${OWNER}/${repo}/HEAD/`}
			as="div"
			noToc={noToc}
		/>
	);
}
